interface Props {
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export default function FilterBar({ children, actions }: Props) {
  return (
    <div className="flex items-center justify-between gap-2 mb-7 flex-wrap">
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
      {actions ? <div className="flex items-center gap-3 shrink-0">{actions}</div> : null}
    </div>
  );
}
